export const copyToClipboard = (input) => {
    try {
        navigator.clipboard.writeText(input);
        return true;
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=copyToClipboard.js.map